/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyFreshserviceIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-freshservice" */ './utils').then((m) => m.FreshserviceIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/freshservice/icon' },
);

const LazyFreshserviceSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-freshservice-search-result" */ './utils').then(
			(m) => m.FreshserviceSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/freshservice/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const FreshserviceIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyFreshserviceIconComponent />
	</Suspense>
);

export const FreshserviceSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyFreshserviceSearchResultIconComponent />
	</Suspense>
);
